import { Grid, Stack, TextField } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FormField, useFormStore } from '@tom-ui/utils'
import { FormProps } from '@yard/app/models/form-props.model'
import { observer } from 'mobx-react-lite'
import { IBayFormData } from '../../models/yard-setup.model'

interface Props extends FormProps {
  label: string
  initialValue?: string
  onSubmit: (formValues: IBayFormData) => Promise<void> | void
}

export const AxisNameForm = observer(({ id, label, initialValue, onSubmit }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const formStore = useFormStore<IBayFormData>()

  const handleSubmit = () => {
    if (formStore.validate()) {
      onSubmit(formStore.data)
    }
  }

  return (
    <Grid
      id={id}
      component='form'
      autoComplete='off'
      noValidate
      container
      onSubmit={event => {
        event.preventDefault()
        handleSubmit()
      }}
      spacing={theme.customSpacing.m}
    >
      <Grid size={12}>
        <FormField
          formStore={formStore}
          name={'name'}
          initialValue={initialValue ?? ''}
          validate={value => {
            if (!value) return t('fieldIsRequired', 'Field is required')
          }}
        >
          {store => (
            <Stack>
              <TextField
                {...store.props}
                autoFocus
                fullWidth
                label={label}
                required
                name='name'
                error={!!store.error}
                helperText={store.error}
              />
            </Stack>
          )}
        </FormField>
      </Grid>
    </Grid>
  )
})
